import React from "react"
import MasteryLevel from "./mastery_level"
import LastStudySession from "./last_study_session"
import NextRecommendedStudySession from "./next_recommended_study_session"

function StudySummary({
  stats,
  open_quiz_mode_modal,
  can_train
}) {
  const full_mastery = stats.mastery_level.mastery === 100

  return (
    <div>
      <NextRecommendedStudySession
        open_quiz_mode_modal={open_quiz_mode_modal}
        next_recommended_study_session={stats.next_recommended_session_in_words}
      />
      <div className="progress-container">
        <MasteryLevel
          mastery_level={stats.mastery_level}
          full_mastery={full_mastery}
        />
        <LastStudySession
          stats={stats}
          open_quiz_mode_modal={open_quiz_mode_modal}
          full_mastery={full_mastery}
          can_train={can_train}
        />
      </div>
    </div>
  )
}

export default StudySummary
